<template>
  <div class="vertical-menu">
    <a href="#" class="title">Requisições API</a>
    <template v-for="d in documents">
      <a :href="`#${d.linkNav}`" :key="d.linkNav"> {{ d.title }} </a>
    </template>
  </div>

</template>

<script>
export default {
  name: 'nav-profile',
  props: {
    documents: Array
  },
  data() {
    return {}
  },
  created() {
    
  },
  methods: {
    
  }
};
</script>

<style scoped>
.vertical-menu {
  overflow: auto;
  width: auto;
  max-height: 100vh;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
  color: #000000  !important;
  text-decoration: none !important;
}

.vertical-menu a.title {
  background-color: #000000;
  color: white;
}

.vertical-menu a.title:hover {
  background-color: #000000;
  color: white !important;
  text-decoration: none !important;
}
    
</style>
